<template>
  <section class="container">
    <div class="order" v-for="(item, index) in orders" :key="index">
      <van-cell title="订单信息" size="large">
        <svg-icon slot="icon" class="order__icon" icon-class="我的订单" />
      </van-cell>
      <van-cell border size="large">
        <span slot="title">
          <van-row>
            <van-col span="6">订单编号</van-col>
            <van-col span="18" class="order__info">
              {{ item.outTradeNo.split('_')[0] }}
            </van-col>
          </van-row>
        </span>
      </van-cell>
      <van-cell border size="large">
        <span slot="title">
          <van-row>
            <van-col span="6">车牌号码</van-col>
            <van-col span="18" class="order__info">
              {{ item.cardNumber }}
            </van-col>
          </van-row>
        </span>
      </van-cell>
      <van-cell border size="large">
        <span slot="title">
          <van-row>
            <van-col span="6">车场名称</van-col>
            <van-col span="18" class="order__info">{{ item.parkName }}</van-col>
          </van-row>
        </span>
      </van-cell>
      <van-cell border size="large">
        <span slot="title">
          <van-row>
            <van-col span="6">支付时间</van-col>
            <van-col span="18" class="order__info">
              {{ item.orderPayTime }}
            </van-col>
          </van-row>
        </span>
      </van-cell>
      <van-cell border size="large">
        <span slot="title">
          <van-row>
            <van-col span="6">支付金额</van-col>
            <van-col span="13" class="order__money">
              ¥
              {{ (item.paidMoney / 100).toFixed(2) }}
            </van-col>
            <van-col span="5" class="order__info" v-if="config.projectName != 'YNTC'">
              <van-button size="small" type="info" style="padding:10px" @click="submitInvoicing(item)">
                {{invoiceText(item.billingStatus)}}
              </van-button>

            </van-col>
          </van-row>
        </span>
      </van-cell>
    </div>
  </section>
</template>

<script>
import { Row, Col, Icon, NoticeBar } from 'vant'
import { SetIssuer, GCInvoicing, getSellerInformationByParkId, getPDFUEL } from '@/api/invoice'
import config from '@/config/index'
import { mapGetters } from 'vuex'
export default {
  props: {
    orders: {
      type: Array,
      default () {
        return {}
      }
    }
  },
  components: {
    [Row.name]: Row,
    [Col.name]: Col,
    [Icon.name]: Icon,
    [NoticeBar.name]: NoticeBar
  },
  computed: {
    ...mapGetters(['wx_userInfo', 'token']),
    invoiceText () {
      return function (item) {
        if (item == 0) {
          return '开具发票'
        } else {
          if (this.config.projectName == 'JNJT') {
            return '查看发票'
          } else {
            return '已开票'
          }
        }
      }
    }
  },
  data () {
    return {
      showList: false,
      config
    }
  },
  mounted () {
    console.log(2)

    console.log(this.orders)
  },
  methods: {
    // 正则验证url地址
    CheckUrl (item) {
      let pattern = /^((https|http|ftp|rtsp|mms)?:\/\/)[^\s]+/;
      return pattern.test(item)
    },
    // 发票
    submitInvoicing (item) {
      console.log(item)
      let _this = this
      if (item.isInvoice == 1) {
        if (_this.$enumObject.providerConfig[config.projectName].invoicingParty == 'hx') {
          let getInfo_Loading = this.$toast.loading('加载中...')
          let params = {
            fpqqlsh: item.other1,
            parkId: item.parkId,
          }
          getPDFUEL(params).then(res => {
            getInfo_Loading.clear()
            if (res.status == 1001) {
              //地址路径在message
              if (_this.CheckUrl(res.body.list[0].c_imgUrls)) {
                window.location.href = res.body.list[0].c_imgUrls
              } else if (_this.CheckUrl(res.body.list[0].c_url)) {//pdf或者订单号
                window.location.href = res.body.list[0].c_url
              } else {
                _this.$notify({
                  type: 'danger',
                  message: '开票失败，请联系管理员。'
                })
                return
              }
              _this.$notify({
                type: 'success',
                message: '开票成功，请查看邮箱。'
              })
            } else if (res.status === 1002) {
              _this.$notify({
                type: 'primary',
                message: '正在开票中，请稍后。'
              })
            } else {
              _this.$notify({
                type: 'danger',
                message: '开票失败，请重试。'
              })
            }
          })
        } else {
          _this.$toast('此订单已开具')
        }
      } else {
        let params = {
          parkId: Number(item.parkId),
          isRoadsideOrParking: _this.$enumObject.providerConfig[config.projectName].otherConfig.parkType
        }
        if (this.config.projectName == 'GCTC') {
          getSellerInformationByParkId(params).then(res => {
            if (!res.body) {
              _this.$toast.fail('暂无销售方信息');
              return
            }
            GCInvoicing(item).then(res => {
              console.log(res)
              if (res.status == 1001) {
                _this.$notify({
                  type: 'success',
                  message: '开票成功'
                })
                this.$parent.componentsValve();
              } else {
                _this.$notify({
                  type: 'danger',
                  message: '开票失败，请联系管理员'
                })
              }
            }).catch(err => {
              _this.$notify({
                type: 'danger',
                message: err
              })
            })


          })
            .catch(err => {
              _this.$notify({
                type: 'danger',
                message: err
              })
            })
        } else {
          SetIssuer(params).then(res => {
            if (!res.body) {
              _this.$toast.fail('暂无销售方信息');
              return
            }
            if (res.body.invoiceMerchant == 1) {
              let params = {
                openid: res.body.openid,
                appsecret: res.body.appSecret,
              }
              this.$store.dispatch('invoice/GetToken', params)
            }
            _this.$router.push({ name: 'Invoice-Form' })
            _this.$store.dispatch('invoice/SetInvoiceInfo', res.body)
            _this.$store.dispatch('invoice/SetPendingBill', [item])
          })
            .catch(err => {
              _this.$notify({
                type: 'danger',
                message: err
              })
            })
        }

      }
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  background: #f3f4f5;
  height: 100vh;

  .order {
    background: #ffffff;
    margin-bottom: 10px;

    &__icon {
      font-size: 20px;
      color: #4b62ec;
      line-height: 24px;
      margin-right: 8px;
      height: 24px;
    }

    &__id {
      color: #444444;
      font-size: 16px;
      padding: 12px 16px;
      border-bottom: 1px solid #f3f4f5;
      background: #fff;
    }

    /deep/ .van-cell__title {
      color: #444444;

      .order__info {
        font-size: 16px;
      }

      .order__money {
        font-size: 18px;
        color: #49a6ff;
      }
    }
  }
}
</style>